var control_llegenda_WMS;
L.TileLayer.BetterWMS = L.TileLayer.WMS.extend({
	onAdd: function (map) {
		this.creaControlLLegenda(map);
		// Triggered when the layer is added to a map.
		// Register a click listener, then do all the upstream WMS things
		this.options.maxZoom = 20;
		this.options.queryable = true;
		L.TileLayer.WMS.prototype.onAdd.call(this, map);
		map.on('click', function (e) {
			$.publish('createPopupOnclick', { event: e, element: this });
		});
		//var params = this.getLegendGraphic();
		//this.updateControlLLegenda(params,this.wmsParams.layers,true,this.options.nom,this.options.businessId);	
	},
	onRemove: function (map) {
		// Triggered when the layer is removed from a map.
		// Unregister a click listener, then do all the upstream WMS things
		L.TileLayer.WMS.prototype.onRemove.call(this, map);
		//map.off('click', this.getFeatureInfo, this);
		//var params = this.getLegendGraphic();
		//this.updateControlLLegenda(params,this.wmsParams.layers,false,this.options.nom,this.options.businessId);
	},
	getFeatureInfo: function (evt) {
		this.getPopupContent(evt).then(function (data) {
			var pop = L.popup({ maxWidth: 800 })
				.setLatLng(evt.latlng)
				.setContent(data.content).openOn(map);
		});
	},
	getPopupContent: function (evt, index) {
		var defer = $.Deferred();
		var ret = {
			index: index || 0,
			content: ''
		};

		var params = this.getFeatureInfoUrl(evt.latlng);
		params = params.replace("INFO_FORMAT=text%2Fhtml", "INFO_FORMAT=text/html");

		var isBeta = params.indexOf("betaserver.icgc.cat") !== -1;

		if (isBeta) {
			params = params.replace("INFO_FORMAT=text/html", "INFO_FORMAT=text/plain");
			params = params.replace("INFO_FORMAT=text%2Fhtml", "INFO_FORMAT=text/plain");
		}

		if (!this.options.queryable) {
			defer.resolve(ret);
			return defer;
		}

		function doFetch(url) {


			url=url.replace("http:","https:");

			return fetch(url, { method: 'GET' })
				.then(function (response) {
					if (!response.ok) {
						console.error("❌ Fetch HTTP error:", response.status, response.statusText, url);
						throw new Error("HTTP error " + response.status);
					}
					return response.text();
				});
		}

		// 🔹 CAS BETASERVER
		if (isBeta) {
			doFetch(params)
				.then(function (data) {
					ret.content = `
<textarea style="width:100%; height:200px;">
${data}
</textarea>`;
					defer.resolve(ret);
				})
				.catch(function (err) {
					console.error("❌ Fetch error (betaserver):", err, params);
					//ret.content = "<br/>Error obtenint resposta del servidor.";
					ret.content = "<iframe style='width:100%; height:300px; border:none;' src='" + params + "'></iframe>";


					defer.resolve(ret);
				});

			return defer;
		}

		// 🔹 FETCH NORMAL
		doFetch(params)
			.then(function (data) {
				if (data && data.length > 5) {
					ret.content = data;
				} else {
					ret.content = "<br/>El WMS no retorna informació en aquest punt.";
				}
				defer.resolve(ret);
			})
			.catch(function (err) {

				console.error("❌ Fetch error → fallback a proxy:", err, params);

				// 🔹 FALLBACK AJAX
				$.ajax({
					url: paramUrl.proxy_betterWMS,
					data: { url: params },
					success: function (data) {
						var body = "";

						if (typeof data === "string" && data.indexOf("<body>") > -1) {
							body = data.substring(
								data.indexOf("<body>") + 6,
								data.indexOf("</body>")
							);
						}

						body = body.replaceAll("\r", "")
							.replaceAll("\n", "")
							.replaceAll(" ", "");

						if (data && data.length > 5) {
							if (data.indexOf("<body>") > -1 && body === "") {
								ret.content = "<br/>El WMS no retorna informació en aquest punt.";
							} else {
								ret.content = data;
							}
						} else {
							ret.content = "<br/>El WMS no retorna informació en aquest punt.";
						}

						defer.resolve(ret);
					},
					error: function (xhr, status, error) {
						console.error("❌ AJAX proxy error:", {
							status: status,
							error: error,
							response: xhr.responseText,
							url: params
						});

						ret.content = "<br/>El WMS no retorna informació en aquest punt.";
						defer.resolve(ret);
					},
					timeout: 95000
				});

			});

		return defer;
	},
	getPopupContentOld: function (evt, index) {
		var defer = $.Deferred();
		var ret = {
			index: index || 0,
			content: ''
		};
		// Make an AJAX request to the server and hope for the best
		var params = this.getFeatureInfoUrl(evt.latlng);
		params = params.replace("INFO_FORMAT=text%2Fhtml", "INFO_FORMAT=text/html");


		if (params.indexOf("betaserver.icgc.cat") != -1) {
			params = params.replace("INFO_FORMAT=text/html", "INFO_FORMAT=text/plain");
			params = params.replace("INFO_FORMAT=text%2Fhtml", "INFO_FORMAT=text/plain");
		}


		if (this.options.queryable) {
			if ((params.indexOf('instamaps.cat') != -1 || params.indexOf('172.70.1.11') != -1 || params.indexOf('localhost') != -1) && params.indexOf('instaserver') == -1) {
				if (params.indexOf('/geoservicelocal/') != -1) {
					params = params.replace("INFO_FORMAT=text%2Fhtml", "INFO_FORMAT=text%2Fplain");
					params = params.replace("INFO_FORMAT=text/html", "INFO_FORMAT=text/plain");
				}
			} else {
				//De moment, si es un wms creat pel cloudifier, demanem text/pla
				//mes endavant passarem per ogrinfo i podrem demanar HTML amb template
				//per mostrar la informacio
				if (params.indexOf('betaserver.icgc.cat/geoservice/') != -1) {
					//params = params.replace("https","http");
					params = params.replace("INFO_FORMAT=text%2Fhtml", "INFO_FORMAT=text%2Fplain");
					params = params.replace("INFO_FORMAT=text/html", "INFO_FORMAT=text%2Fplain");
					ret.content = "<iframe style=\"display:block; width:100%; height:100%; border:none;\"  src=" + params + " ></iframe>";
					defer.resolve(ret);
				}

			}
			if (params.indexOf('betaserver.icgc.cat/geoservice/') != -1) {
				ret.content = "<iframe style=\"display:block; width:100%; height:100%; border:none;\"  src=" + params + " ></iframe>";
				defer.resolve(ret);

			} else {
				$.ajax({
					url: paramUrl.proxy_betterWMS,
					data: { url: params },
					success: function (data, status, xhr) {
						var err = typeof data === 'string' ? null : data;
						var body = "";
						if (data.indexOf("body") > -1) body = data.substring(data.indexOf("<body>") + 6, data.indexOf("</body>"));
						body = body.replaceAll("\r", "").replaceAll("\n", "").replaceAll(" ", "")
						if (data.length > 5) {
							if (data.indexOf("<body>") > -1 && body == "") {
								ret.content = "<br/>El WMS no retorna informació en aquest punt.";
								defer.resolve(ret);
							}
							else {
								ret.content = data;
								defer.resolve(ret);
							}

						}
						else {
							ret.content = "<br/>El WMS no retorna informació en aquest punt.";
							defer.resolve(ret);
						}
					},
					error: function (xhr, status, error) {
						if (params.indexOf('betaserver.icgc.cat/geoservice/') != -1) {
							ret.content = "<iframe style=\"display:block; width:100%; height:100%; border:none;\"  src=" + params + " ></iframe>";
						} else {
							ret.content = "<br/>El WMS no retorna informació en aquest punt.";
						}
						defer.resolve(ret);
					},
					timeout: 5000 // sets timeout to 3 seconds
				});
			}
		}
		else {
			defer.resolve(ret);
		}
		return defer;
	},
	getFeatureInfoUrl: function (latlng) {
		var bounds = this._map.getBounds();
		var SRS = this.wmsParams.srs;
		var BBOX = bounds.toBBoxString();
		if (SRS.indexOf('3857') != -1) {
			var NW = L.CRS.EPSG3857.project(bounds.getNorthWest());
			var SE = L.CRS.EPSG3857.project(bounds.getSouthEast());
			BBOX = NW.x + "," + SE.y + "," + SE.x + "," + NW.y;
		}
		// Construct a GetFeatureInfo request URL given a point
		var point = this._map.latLngToContainerPoint(latlng, this._map.getZoom()),
			size = this._map.getSize(),
			params = {
				request: 'GetFeatureInfo',
				service: 'WMS',
				srs: SRS,
				styles: this.wmsParams.styles,
				transparent: this.wmsParams.transparent,
				version: this.wmsParams.version,
				format: this.wmsParams.format,
				bbox: BBOX,
				height: size.y,
				width: size.x,
				//exceptions:'application/vnd.ogc.se_blank',
				layers: this.wmsParams.layers,
				query_layers: this.wmsParams.layers,
				info_format: 'text/html',
				feature_count: '18'	//18 perquè es va fer el dia 18/04/2017
			};
		params[params.version === '1.3.0' ? 'i' : 'x'] = point.x;
		params[params.version === '1.3.0' ? 'j' : 'y'] = point.y;
		var urlApp = document.location.href;
		if (-1 != urlApp.indexOf('geocat1')) this._url = this._url.replace("https", "http");
		return this._url + L.Util.getParamString(params, this._url, true);
	},
	showGetFeatureInfo: function (err, latlng, content) {
		if (err) { console.log(err); return; } // do nothing if there's an error
		// Otherwise show the content in a popup, or something.
		L.popup({ maxWidth: 800 })
			.setLatLng(latlng)
			.setContent(content)
			.openOn(this._map);
	},
	getLegendGraphic: function () {
		//console.debug("getLegendGraphic");
		var _format = this.wmsParams.format;
		_format = _format.replace('png8', 'png');
		var layers = this.wmsParams.layers.split(",");
		if (layers.length === 1) {
			params = {
				request: 'GetLegendGraphic',
				service: 'WMS',
				version: this.wmsParams.version,
				format: _format,
				layer: this.wmsParams.layers
			};
			return this._url + L.Util.getParamString(params, this._url, true);
		} else {
			var legend = [];
			for (var i = 0, length = layers.length; i < length; i++) {
				var layer = layers[i];
				params = {
					request: 'GetLegendGraphic',
					service: 'WMS',
					version: this.wmsParams.version,
					format: _format,
					layer: layer
				};
				legend.push(this._url + L.Util.getParamString(params, this._url, true));
			}
			return legend;
		}

	},
	creaControlLLegenda: function (map) {
		//console.debug("creaControlLLegenda");
		var fet = false;
		if (jQuery('#div_control_wms_llegenda').length == 0) {
			if (map) {
				control_llegenda_WMS = L.control({
					position: 'bottomright'
				});
				control_llegenda_WMS.onAdd = function (map) {
					this._div = L.DomUtil.create('div', 'psolar_infoLL'); // create div with a class
					this._div.id = 'div_control_wms_llegenda';
					this.update();
					return this._div;
				};
				control_llegenda_WMS.update = function (props) {
					this._div.innerHTML = props;
				};
				control_llegenda_WMS.addTo(map);
				control_llegenda_WMS.update("");
				fet = true;
				return fet;
			}
		}
		return fet;
	},
	updateControlLLegenda: function (params, layer, estat, nom, businessId) {
		//TODO borrar
	}
});

L.tileLayer.betterWms = function (url, options) {
	return new L.TileLayer.BetterWMS(url, options);
};